import { Component, OnInit, ElementRef, ViewChild } from '@angular/core'; 
import { orders, products, customers, refunds } from '../dashboard.data';
import { RentingService } from 'src/app/services/renting.service';
import { PaymentService } from 'src/app/services/payment.service';
import { UserServiceService } from 'src/app/services/user-service.service';
import { VehiculeserviceService } from 'src/app/services/vehiculeservice.service';

@Component({
  selector: 'app-info-cards',
  templateUrl: './info-cards.component.html',
  styleUrls: ['./info-cards.component.scss']
})
export class InfoCardsComponent implements OnInit { 
  public orders: any[] = [];
  public products: any[] = [];
  public customers: any[] = [];
  public refunds: any[] = [];
  public locations :any[]=[];
  public payment :any[]=[];
  public users :any[]=[];
  public cars :any[]=[];
  public nbLocation:number|string;
  public nbPaiement: number|string;
  public nbUser:number|string;
  public nbCar: number|string;
  public colorScheme:any = {
    domain: ['rgba(255,255,255,0.8)']
  }; 
  public autoScale = true;
  @ViewChild('resizedDiv') resizedDiv!:ElementRef;
  public previousWidthOfResizedDiv:number = 0; 
 
  constructor(
    private locationService:RentingService,
    private paiementService:PaymentService,
    private userService:UserServiceService,
    private carService:VehiculeserviceService
    ){ }

  ngOnInit(){
    this.orders = orders;
    this.products = products;
    this.customers = customers;
    this.refunds = refunds;
    this.orders = this.addRandomValue('orders');     
    this.customers = this.addRandomValue('customers');
    this.loadData();
  }


  public loadData()
  {
    this.locationService.index('none').subscribe((res:any)=>{
      console.log(res);
       if(res.rentings.length >0)
        this.nbLocation = res.rentings.length <=9?'0'+res.rentings.length:res.rentings.length;
       else  
        this.nbLocation = "00";     
    })

    this.paiementService.index().subscribe((res:any)=>{
      console.log(res);
      if(res.paiements.length >0)
        this.nbPaiement = res.paiements.length <=9?'0'+res.paiements.length:res.paiements.length;
       else  
        this.nbPaiement = "00";
    })

    this.userService.getUser().subscribe((res:any)=>{
      console.log(res);
      if(res.length >0)
        this.nbUser = res.length <=9?'0'+res.length:res.length;
      else  
        this.nbUser = "00";       
    })

    this.carService.getallvehicleAdmin().subscribe((res:any)=>{
      console.log(res);
      if(res.length >0)
        this.nbCar = res.length <=9?'0'+res.length:res.length;
      else  
      this.nbCar = "00";
    })

    this.locationService.indexOn10Years().subscribe((res:any)=>{
      this.locations =[{name:'Locations',series:res.rentings}]
    })

    this.paiementService.index10OnYears().subscribe((res:any)=>{
      this.payment =[{name:'Paiements',series:res.paiements}]
    })

    this.userService.getUserOn10Ans().subscribe((res:any)=>{
      this.users =[
        {
          name:'Utilisateurs',
          series:res
        }
      ]
    })

    this.carService.getallNbvehicleOn10Years().subscribe((res:any)=>{
      this.cars =[
        {
          name:'Vehicules',
          series:res
        }
      ]
      console.log(res);
    })
  }
  
  public onSelect(event:any) {
    console.log(event);
  }

  public addRandomValue(param:string) {
    switch(param) {
      case 'orders':
        for (let i = 1; i < 30; i++) { 
          this.orders[0].series.push({"name": 1980+i, "value": Math.ceil(Math.random() * 1000000)});
        } 
        return this.orders;
      case 'customers':
        for (let i = 1; i < 15; i++) { 
          this.customers[0].series.push({"name": 2000+i, "value": Math.ceil(Math.random() * 1000000)});
        } 
        return this.customers;
      default:
        return this.orders;
    }
  }

  ngOnDestroy(){
    this.orders[0].series.length = 0;
    this.customers[0].series.length = 0;
  }

  ngAfterViewChecked() {    
    if(this.previousWidthOfResizedDiv != this.resizedDiv.nativeElement.clientWidth){
      setTimeout(() => this.orders = [...orders] ); 
      setTimeout(() => this.products = [...products] ); 
      setTimeout(() => this.customers = [...customers] ); 
      setTimeout(() => this.refunds = [...refunds] );
    }
    this.previousWidthOfResizedDiv = this.resizedDiv.nativeElement.clientWidth;
  }

}